import { render, staticRenderFns } from "./SSRApp.vue?vue&type=template&id=6e05c3ec&"
import script from "./SSRApp.vue?vue&type=script&lang=ts&"
export * from "./SSRApp.vue?vue&type=script&lang=ts&"
import style0 from "./SSRApp.vue?vue&type=style&index=0&id=6e05c3ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports